import { Select as AntdSelect } from 'antd'
import { useEffect, useState } from 'react'

import AtomSelect from '@/components/Atoms/AtomSelect/AtomSelect'
import { useExcelFileUploaderStore } from '@/stores/import/excelFileUploaderStore'
import { OptionType } from '@/types'

import HoverElement from '../../../../Atoms/HoverElement/HoverElement'
import cn from './ExcelFilePreviewDataTableHeadCell.module.scss'

type PreviewDataTableHeaderTitlePropsType = {
  index: number
  sheet: string
  previewDataColumnMappingOptions: { value: string; label: string }[]
}

const { Option } = AntdSelect

function ExcelFilePreviewDataTableHeadCell(
  props: PreviewDataTableHeaderTitlePropsType
) {
  const { index, sheet, previewDataColumnMappingOptions } = props

  const [option, setOption] = useState<string>('')

  const { previewDataColumnMapping, setPreviewDataColumnMapping } =
    useExcelFileUploaderStore((state) => state)

  useEffect(() => {
    setOption('')
    Object.keys(previewDataColumnMapping[sheet]).forEach((key) => {
      if (previewDataColumnMapping[sheet][key] == index + 1) {
        setOption(key)
      }
    })
  }, [sheet, previewDataColumnMapping, index])

  const handleChange = (
    _: string | OptionType | (() => string) | null,
    option:
      | { value: string; label: string }
      | { value: string; label: string }[]
      | undefined
  ) => {
    void _

    if (!option || Array.isArray(option)) {
      return
    }

    const { value } = option
    setPreviewDataColumnMapping({}, value, index + 1, sheet)
    setOption(value)
  }

  return (
    <div className={cn.previewDataTableHeaderTitle}>
      <span>{index + 1}</span>
      <HoverElement>
        <AtomSelect value={option} handleChange={handleChange}>
          {previewDataColumnMappingOptions.map((opt) => {
            return (
              <Option
                value={opt.value}
                disabled={
                  previewDataColumnMapping[sheet][opt.value] != -1 && opt.value
                }
                key={opt.value}
              >
                {opt.label}
              </Option>
            )
          })}{' '}
        </AtomSelect>
      </HoverElement>
    </div>
  )
}

export default ExcelFilePreviewDataTableHeadCell
